module.exports = __webpack_public_path__ + "static/media/mug.d15bb638.svg";